import axios from "axios";

export const fetchAdvertisementsData = (token, page) => async (dispatch) => {
    dispatch({ type: "FETCH_ADVERTISEMENTS_REQUEST" });

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getAllAdvertisements?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: "FETCH_ADVERTISEMENTS_SUCCESS",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_ADVERTISEMENTS_FAILURE",
        payload: error.message,
      });
    }
};
